import { render, staticRenderFns } from "./ig-iframe.vue?vue&type=template&id=5031d748&scoped=true"
import script from "./ig-iframe.vue?vue&type=script&lang=js"
export * from "./ig-iframe.vue?vue&type=script&lang=js"
import style0 from "./ig-iframe.vue?vue&type=style&index=0&id=5031d748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031d748",
  null
  
)

export default component.exports